import { render } from "./MailBox.vue?vue&type=template&id=6139fbef&scoped=true"
import script from "./MailBox.vue?vue&type=script&lang=js"
export * from "./MailBox.vue?vue&type=script&lang=js"

import "./MailBox.vue?vue&type=style&index=0&id=6139fbef&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6139fbef"]])

export default __exports__